(() => {
  "use strict";

  window.zag = window.zag || {};

  window.zag.components.ZagReadMore = class extends (
    window.zag.components.ZagComponent
  ) {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.readMoreButton) {
        this.events.add(
          this.readMoreButton,
          "click",
          this.onReadMoreButtonClick
        );
      }
    }

    get details() {
      return this.cache.get("dom", "details", () => {
        return this.section.querySelector("details");
      });
    }

    get readMoreButton() {
      return this.cache.get("dom", "readMoreButton", () => {
        return this.section.querySelector(".read-more-button");
      });
    }

    onReadMoreButtonClick = async () => {
      await this.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      this.details.open = !this.details.open;
      this.updateButtonText();
    };

    updateButtonText = () => {
      if (this.details.open) {
        this.readMoreButton.textContent = this.readMoreButton.dataset.readLess;
      } else {
        this.readMoreButton.textContent = this.readMoreButton.dataset.readMore;
      }
    };
  };
  if (!window.customElements.get("zag-read-more")) {
    window.customElements.define(
      "zag-read-more",
      window.zag.components.ZagReadMore
    );
  }
})();
